import { render, staticRenderFns } from "./RoleMenuManagement.vue?vue&type=template&id=b0211614&scoped=true&"
import script from "./RoleMenuManagement.vue?vue&type=script&lang=js&"
export * from "./RoleMenuManagement.vue?vue&type=script&lang=js&"
import style0 from "./RoleMenuManagement.vue?vue&type=style&index=0&id=b0211614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0211614",
  null
  
)

export default component.exports